import { combineReducers } from 'redux';
import { tags } from './tags';
import { offersCount } from './offersCount';
import { IStateTag } from '../../actions/filterTags/definitionFactory';
import { IStateOffersCount } from '../../actions/offersData';

export interface IFilterState {
  tags: IStateTag[];
  offersCount: IStateOffersCount;
}

export const filters = combineReducers<IFilterState>({
  tags,
  offersCount,
});
